













































import {Component, Vue, Ref, Prop, Watch } from 'vue-property-decorator';
import { FormModel } from 'ant-design-vue';
import { IOwnerInfo } from '../types';

type IUserDetailInfo = IUser.IResponse.IUserDetailInfo;
type ISettlementUnitInfo = ISettlementUnit.IResponse.ISettlementUnitInfo;

interface IForm {
  ownerId: string;
  value: number | null;
  settlementUnitId: string;
}

@Component
export default class OwnerForm extends Vue {
  @Ref() private readonly ownerForm!: FormModel;
  @Prop({required: true}) private owner!: IOwnerInfo;
  @Prop({required: true, default: () => []}) private ownerOptions!: IUserDetailInfo[];
  @Prop({required: true, default: () => []}) private settlementUnitOptions!: ISettlementUnitInfo[];
  @Prop({default: ''}) private index!: number;
  @Prop({default: 2}) private precision!: number;
  private form: IForm = {
    ownerId: '',
    value: null,
    settlementUnitId: '',
  };
  private filterOwnerOptions: IUserDetailInfo[] = this.ownerOptions.map((user) => user);
  private rules = {
    ownerId: [{ required: true, trigger: 'change', message: () => this.$t('form.required')}],
    value: [{ required: true, trigger: 'blur', message: () => this.$t('form.required') }],
    settlementUnitId: [{ required: true, trigger: 'change', message: () => this.$t('form.required') }],
  };
  public validate(): boolean {
    let validateResult: boolean = false;
    this.ownerForm.validate((valid) => {
      validateResult = valid;
      if (valid) {
        this.syncUpdate();
      } else {
        return false;
      }
    });
    return validateResult;
  }
  @Watch('owner', {immediate: true})
  private watchClause(newValue: IOwnerInfo) {
    this.form = {...newValue};
  }
  private syncUpdate() {
    this.$emit('update:owner', this.form);
  }
  private valueChange() {
    this.syncUpdate();
    this.$emit('valueChange');
  }
  private handleSearch(input: string) {
    this.filterOwnerOptions = this.ownerOptions.filter((user) => {
      return user.name.toLowerCase().indexOf(input.toLowerCase()) > -1;
    });
  }
}
